import type { Card, Coluna } from '../types'
import KanbanCard from './KanbanCard'

interface Props {
  coluna: Coluna
  cards: Card[]
  onCardClick: (card: Card) => void
  onDrop: (cardId: number, colunaId: string) => void
  onNewCard: () => void
}

export default function KanbanColumn({ coluna, cards, onCardClick, onDrop, onNewCard }: Props) {
  return (
    <div
      className="flex flex-col bg-gray-100 rounded-xl w-72 shrink-0"
      onDragOver={(e) => { e.preventDefault(); e.dataTransfer.dropEffect = 'move' }}
      onDrop={(e) => {
        e.preventDefault()
        const cardId = Number(e.dataTransfer.getData('card-id'))
        if (cardId) onDrop(cardId, coluna.id)
      }}
    >
      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2.5">
        <span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: coluna.cor }} />
        <h3 className="text-sm font-semibold text-gray-700 flex-1">{coluna.nome}</h3>
        <span className="text-xs text-gray-400 bg-gray-200 px-1.5 py-0.5 rounded-full">{cards.length}</span>
      </div>

      {/* Cards */}
      <div className="flex-1 overflow-y-auto px-2 pb-2 space-y-2 min-h-[100px]">
        {cards.map((c) => (
          <KanbanCard key={c.id} card={c} onClick={() => onCardClick(c)} />
        ))}
      </div>

      {/* Add button */}
      <button
        onClick={onNewCard}
        className="mx-2 mb-2 text-sm text-gray-400 hover:text-gray-600 hover:bg-gray-200 rounded-lg py-1.5 transition-colors"
      >
        + Novo card
      </button>
    </div>
  )
}
